import React, { useState } from 'react';
import { Combobox, ComboboxInput, ComboboxButton, ComboboxOptions, ComboboxOption } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import createApiInstance from '../utilities/apiAuth';

function RoleDropdown({ value, userId, onUpdate, disabled}) {
  const [selectedRole, setSelectedRole] = useState(value); // Manage local state for selected role
  const roles = ['agent', 'admin'];

  const handleRoleChange = async (newRole, disabled) => {
    setSelectedRole(newRole); // Update local state immediately for UI feedback
    console.log('newRole:', newRole);
    if(disabled) return;
    try {
      const api = createApiInstance();
      await api.put(`/user/${userId}/update-role`, { role: newRole });
      if (onUpdate) onUpdate(newRole); // Notify parent component of the change
    } catch (error) {
      console.error('Error updating role:', error);
    }
  };

  return (
    <Combobox value={selectedRole} onChange={handleRoleChange} by={(a, b) => a === b}>
      <div className={`relative w-40 ${disabled ? 'pointer-events-none opacity-50' : ''}`}>
        <div className="relative w-40">
          <div className="relative">
            <ComboboxInput
              className="border border-gray-300 p-2 w-full rounded-md cursor-pointer"
              displayValue={(role) => role.charAt(0).toUpperCase() + role.slice(1)} // Capitalize role
              onChange={() => {}} // Prevent manual input
              readOnly
            />
            <ComboboxButton className="absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronDownIcon className="h-5 w-5 text-gray-400" />
            </ComboboxButton>
          </div>
          <ComboboxOptions className="w-full absolute mt-1 bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm cursor-pointer z-50">
            {roles.map((role) => (
              <ComboboxOption
                key={role}
                value={role}
                className={({ active, selected }) =>
                  `cursor-pointer select-none relative py-2 pl-10 pr-4 ${
                    active ? 'bg-indigo-600 text-white' : 'text-gray-900'
                  } ${selected ? 'font-bold' : 'font-normal'}`
                }
              >
                {({ active, selected }) => (
                  <span className={`block truncate ${selected ? 'font-bold' : 'font-normal'} ${active ? 'bg-indigo-600 text-white' : 'text-gray-900'}`}>
                    {role.charAt(0).toUpperCase() + role.slice(1)}
                  </span>
                )}
              </ComboboxOption>
            ))}
          </ComboboxOptions>
        </div>
      </div>
    </Combobox>
  );
}

export default RoleDropdown;